import {Link} from "react-router-dom";

function RecentBlog() {
    return (
        <>
            <section className="blogSec">
                <div className="container">
                    <div className="title">
                        <h2 className="secHeading" data-aos='fade-up'>
                            Our Recent Blog
                        </h2>
                        <p data-aos='fade-up' data-aos-delay='100'>
                            In publishing and graphic design, Lorem ipsum is a placeholder text commonly
                        </p>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="cardStack">
                                <Link to='' className="blogCard">
                                    <figure data-aos='fade-in' data-aos-delay='100'>
                                        <img src={process.env.PUBLIC_URL + "/images/blog1.webp"} alt=""/>
                                    </figure>
                                    <div className="content">
                                        <h6 data-aos='fade-up' className="date">Aug 26, 2023</h6>
                                        <h3 data-aos='fade-up' data-aos-delay='100' className='blogName'>
                                            Coding Bootcamp
                                        </h3>
                                        <p>
                                            A golden ticket to a six-figure job? Not exactly. An intense learning
                                            experience that can launch a new career?
                                        </p>
                                        <div className="tags">
                                            <span className="tag blue">bootstrap</span>
                                            <span className="tag green">UI/UX</span>
                                            <span className="tag red">tools</span>
                                        </div>
                                    </div>
                                </Link>
                                <Link to='' className="blogCard">
                                    <figure data-aos='fade-in' data-aos-delay='100'>
                                        <img src={process.env.PUBLIC_URL + "/images/blog2.webp"} alt=""/>
                                    </figure>
                                    <div className="content">
                                        <h6 data-aos='fade-up' className="date">Aug 26, 2023</h6>
                                        <h3 data-aos='fade-up' data-aos-delay='100' className='blogName'>
                                            Learning Python
                                        </h3>
                                        <p>
                                            A golden ticket to a six-figure job? Not exactly. An intense learning
                                            experience that can launch a new career?
                                        </p>
                                        <div className="tags">
                                            <span className="tag blue">Deep learning</span>
                                            <span className="tag green">UI/UX</span>
                                            <span className="tag red">tools</span>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="cardStack">
                                <Link to='' className="blogCard max">
                                    <figure data-aos='fade-in' data-aos-delay='100'>
                                        <img src={process.env.PUBLIC_URL + "/images/blog3.webp"} alt=""/>
                                    </figure>
                                    <div className="content">
                                        <h6 data-aos='fade-up' className="date">Aug 26, 2023</h6>
                                        <h3 data-aos='fade-up' data-aos-delay='100' className='blogName'>
                                            The Ultimate Guide to UX/UI Design Tools
                                        </h3>
                                        <p>
                                            A golden ticket to a six-figure job? Not exactly. An intense learning
                                            experience that can launch a new career?
                                        </p>
                                        <div className="tags">
                                            <span className="tag blue">UI/UX Design</span>
                                            <span className="tag green">Figma</span>
                                            <span className="tag red">tools</span>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default RecentBlog